import React from 'react'
import Crosole from '../../Crosole/Crosole'


const Home = () => {
  return (
    <div>
      <Crosole/>
    </div>
  )
}

export default Home
